import {
  MyApprovalsIcon,
  NeedOffersIcon,
  OpenPOSIcon,
  ReadyForPOIcon,
  SkuResolutionIcon,
  StuckIcon,
} from 'assets/icons/ProcurementDashboard'
import styled from 'styled-components'
import { Flex } from 'styling/GlobalStyles'
import { ColorVariant, Heading1, SmallText, TinyText } from 'styling/TypographyV2'
import { ProcurementDashboardCountsResponse } from 'types/procurement'

type TItem = {
  icon: React.ReactNode
  title: string
  description: string
  count: number
  color: string
}

export const DashboardCount = ({ counts }: { counts?: ProcurementDashboardCountsResponse }) => {
  const items: TItem[] = [
    {
      icon: <MyApprovalsIcon />,
      title: 'My Approvals',
      description: 'Waiting for action',
      count: counts?.myApprovalsCount || 0,
      color: '#F4D03F',
    },
    {
      icon: <NeedOffersIcon />,
      title: 'Need Offers',
      description: 'In sourcing',
      count: counts?.needOffersCount || 0,
      color: '#00A6FF',
    },
    {
      icon: <SkuResolutionIcon />,
      title: 'Sku Resolution',
      description: 'Free text pending',
      count: counts?.skuResolutionCount || 0,
      color: '#AF52DE',
    },
    {
      icon: <ReadyForPOIcon />,
      title: 'Ready for PO',
      description: 'Fully approved',
      count: counts?.readyForPoCount || 0,
      color: '#24D07B',
    },
    {
      icon: <OpenPOSIcon />,
      title: 'Open POs',
      description: 'Waiting receipts',
      count: counts?.openPurchaseOrdersCount || 0,
      color: '#30B0C7',
    },
    {
      icon: <StuckIcon />,
      title: 'STUCK > 7',
      description: 'Needs attention',
      count: counts?.stuckedPurchaseOrdersCount || 0,
      color: '#E74C3C',
    },
  ]

  return (
    <CountContainer>
      {items.map((item) => (
        <Item key={item.title} item={item} />
      ))}
    </CountContainer>
  )
}

const Item = ({ item }: { item: TItem }) => {
  return (
    <ItemContainer hexColor={item.color}>
      <IconContainer hexColor={item.color}>{item.icon}</IconContainer>
      <Flex column gap='4px'>
        <Heading1>{item.count}</Heading1>
        <SmallText colorVariant={ColorVariant.SECONDARY} uppercase bold>
          {item.title}
        </SmallText>
        <TinyText colorVariant={ColorVariant.FADED}>{item.description}</TinyText>
      </Flex>
    </ItemContainer>
  )
}

const ItemContainer = styled.div<{ hexColor: string }>`
  height: 100px;
  border-left: 2px solid ${(props) => props.hexColor};
  ${(props) => props.theme.container};
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 10px 12px 10px 16px;
`
const IconContainer = styled.div<{ hexColor: string }>`
  width: 32px;
  height: 32px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.hexColor}20;
  border-radius: 5px;

  svg {
    path {
      stroke: ${(props) => props.hexColor};
    }
  }
`

const CountContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 20px;
  color: ${(props) => props.theme.textColor};
`
